import React from "react";
import Question from "./Question";
import QuestionBullets from "./QuestionBullets";
import Intro from "./Intro";
import Header from "./Header";
import Footer from "./Footer";
import Translation from "../i18n";

class Questions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentQuestion: -1,
            summary: [],
            finish: false,
            seenQuestions: 0,
            outsideWindow: false
        };
        this.updateSummary = this.updateSummary.bind(this);
        this.nextQuestion = this.nextQuestion.bind(this);
        this.goToQuestion = this.goToQuestion.bind(this);
        this.setFinish = this.setFinish.bind(this);
    }

    nextQuestion() {
        const currentQuestion = this.state.currentQuestion;
        this.setState({currentQuestion: (currentQuestion + 1)});

        const seenQuestions = this.state.seenQuestions;
        if(seenQuestions + 1 <= currentQuestion + 1) {
            this.setState({seenQuestions: (seenQuestions + 1)});
        }
    }

    goToQuestion(question) {
        this.setState({currentQuestion: question})
    }

    updateSummary(p) {

        const existingSummary = this.state.summary;

        const objIndex = existingSummary.findIndex((obj => obj.identifier === p.identifier));

        if(objIndex === -1) {
            this.setState({
                summary: [...this.state.summary, p]
            });
        } else {
            existingSummary[objIndex] = p;
            this.setState({summary: existingSummary});
        }

        if(p.toRemove) {
            if(objIndex !== -1) {
                existingSummary.splice(objIndex, 1);
            }
        }

        // console.log(JSON.stringify(this.state.summary));

    }

    setFinish() {
        this.setState({finish: true});
    }

    render() {
        const questionnaireTitle = this.props.data['metadata']['result']['title'];
        const questionnaireDescription = this.props.data['metadata']['result']['description'];
        const questionnaireImage = this.props.data['metadata']['result']['image'];
        const questionnaireIdentifier = this.props.data['metadata']['result']['identifier'];
        const questions = this.props.data['metadata']['result']['children'];
        const response = this.props.data['metadata']['response'];

		const questionnaireId = this.props.data['questionnaireId'];

        return (
            <>
                {response === 'error' &&
                    <>
                        <Header title="Fehler!" />
                        <div className="d-block text-center finish mt-5">
                            <div className="row">
                                <div className="col-md-9 mx-auto">
                                    <h3>
                                        <Translation i18n="notAvailable" />
                                    </h3>
                                    <a href="https://www.moodmap.at" target="_blank" rel="noreferrer"
                                       className="btn btn-secondary mt-5">
                                        <Translation i18n="moreAbout" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {response !== 'error' &&
                    <Header title={questionnaireTitle + (this.state.finish ? ' abgeschlossen' : '')} />
                }
                <div id="questions" data-questionnaire={questionnaireIdentifier} className="container my-5">
                    {response !== 'error' &&
                        <>
                            {this.state.currentQuestion === -1 &&
                                <>
                                    <Intro description={questionnaireDescription} image={questionnaireImage} questionnaireId={questionnaireId} />
                                    <div className="d-block text-center">
                                        <button type="button" className="btn btn-secondary mx-auto mt-5"
                                                onClick={() => this.goToQuestion(0)}><Translation i18n="start" />
                                        </button>
                                    </div>
                                </>
                            }
                        </>
                    }
                    {!this.state.finish &&
                        <>
                            {this.state.currentQuestion !== -1 &&
                                <>
                                    <QuestionBullets questions={questions} currentQuestion={this.state.currentQuestion} seenQuestions={this.state.seenQuestions} goToQuestion={(p) => this.goToQuestion(p)}/>
                                    {questions &&
                                        <>
                                            {questions.map((question, i) => {
                                                return (<Question key={'question' + i} question={question} updateSummary={(p) => this.updateSummary(p)} nextQuestion={this.nextQuestion} questionPos={i+1} questionsLength={questions.length} render={this.state.currentQuestion === i} finish={() => this.setFinish()} questionnaireId={this.props.data.questionnaireId} summary={this.state.summary} />)
                                            })}
                                        </>
                                    }
                                </>
                            }
                        </>
                    }
                    {this.state.finish &&
                        <>
                            <div className="d-block text-center finish">
                                <div className="row">
                                    <div className="col-md-9 mx-auto">
                                        <h1>
                                            <Translation i18n="thankYou" />
                                        </h1>
                                        <h3>
                                            <Translation i18n="isFinish" />
                                        </h3>
                                        <h4><Translation i18n="endInfo1" /> <br/><Translation i18n="endInfo2" /></h4>
                                        <h5 className="text-secondary"><strong><Translation i18n="endInfo3"/></strong></h5>
                                        <a href="https://www.moodmap.at" target="_blank" rel="noreferrer"
                                           className="btn btn-secondary mt-5">
                                            <Translation i18n="moreAbout" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
                <Footer />
            </>
        );
    }
}

export default Questions;
